<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="title" width="600px" @close="close">
    <div slot="content">
      <el-form :model="formData" ref="templateInfoForm" class="mr-b30" :rules="rules">
        <el-row>
          <el-form-item label="템플릿 제어 IP" prop="vmManagerUrl">
            <el-input v-model="formData.vmManagerUrl" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-row>
        <!-- <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item prop="vmManagerId" label="아이디">
              <el-input style="width:100%" v-model="formData.vmManagerId" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vmManagerPassword" label="비밀번호">
              <el-input type="password" style="width:100%" v-model="formData.vmManagerPassword" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </div>
    <el-row slot="footer" type="flex" justify="end">
      <el-button class="mr-r4" size="large" type="solid" @click="onSaveVmSetting">완료</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { mapGetters } from 'vuex';
import DeviceRegistrationVmsAPI from '@/api/settings/common/device-registration-vms';
import MgrApi from '@/api/model/mgr';
import { cloneDeep, isEqual } from 'lodash';
import { getValueAfterCheckEmpty, validateIpv4 } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';

export default {
  name: 'WTemplateManagementSettingPopup',
  data() {
    return {
      templateFlag: false,
      formData: {
        vmManagerUrl: null,
        vmManagerId: null,
        vmManagerPassword: null,
      },
      rowData: {},
      originVmInfo: null,
      rules: {
        vmManagerUrl: {
          validator: this.validateIpaddress,
          trigger: 'blur',
        },
      },
      title: '',
    };
  },
  computed: mapGetters(['userInfo']),
  methods: {
    open(row, formData) {
      this.$refs.slidingPopup.visible = true;
      this.loadData(row, formData);
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.initData();
    },
    loadData(row, formData) {
      this.title = `${row.vmName} 수정`;
      this.rowData = cloneDeep(row);
      this.formData = cloneDeep(formData);
    },
    initData() {
      this.formData = {
        vmManagerUrl: null,
        vmManagerId: null,
        vmManagerPassword: null,
      };
    },
    onSaveVmSetting() {
      this.$refs.templateInfoForm.validate().then((res) => {
        if (res) {
          const params = {
            vmId: this.rowData.vmId,
            ...this.formData,
          };
          if (isEqual(this.originVmInfo, this.vmInfo)) {
            params.vmsParameterVo = this.rowData;
            params.vmInfo = this.vmInfo;
          }
          DeviceRegistrationVmsAPI.setVirtualTemplateSettingInfo(params).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getCustomResultMsgData('저장하였습니다.', true));
              this.close();
              this.$emit('load-data');
            } else {
              this.$message(msgUtil.getCustomResultMsgData('저장하지 못하였습니다.', false));
            }
          });
        }
      });
    },
    onChangeDatePicker(date) {
      this.formData.expireDate = date;
    },
    getValueAfterCheckEmpty(value) {
      return getValueAfterCheckEmpty(value);
    },
    validateIpaddress(rule, value, callback) {
      if (validateIpv4(value)) {
        callback();
      } else {
        callback(new Error('올바른 IPv4 주소형식을 입력해주세요'));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Virtual/popup/TemplateManagementSettingPopup.vue